/**
 * Mock Security Policy Data
 *
 * Seed for the Security Settings screen in mock mode. Mirrors the backend
 * SecurityPolicy schema defaults (see security_policy_schema.py).
 */

import { DEFAULT_SECURITY_POLICY } from '@/types/securityPolicy.types'
import type { SecurityPolicy } from '@/types/securityPolicy.types'

export const mockSecurityPolicy: SecurityPolicy = {
  passwordPolicy: { ...DEFAULT_SECURITY_POLICY.passwordPolicy },
  sessionPolicy: { ...DEFAULT_SECURITY_POLICY.sessionPolicy },
  loginPolicy: { ...DEFAULT_SECURITY_POLICY.loginPolicy },
}
